import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { EmbryoService } from '../../../Services/Embryo.service';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'HeaderThree',
  templateUrl: './HeaderThree.component.html',
  styleUrls: ['./HeaderThree.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class HeaderThreeComponent implements OnInit {

   cartProducts     : any;
   popupResponse    : any;

   constructor(public embryoService: EmbryoService, translate:TranslateService) { }

   ngOnInit() {
   }

   public toggleSidebar()
   {
      this.embryoService.sidenavOpen = !this.embryoService.sidenavOpen;
   }

   public toggleSearch() {
      $('app-main').toggleClass('form-open');
   }

   public openConfirmationPopup(value:any) {
      let message = "Are you sure you want to delete this product?";
      this.embryoService.confirmationPopup(message).
         subscribe(res => {this.popupResponse = res},
                   err => console.log(err),
                   ()  => this.getPopupResponse(this.popupResponse, value, 'cart')
                  );
   }

   public getPopupResponse(response:any, value:any, type) {
      if(response) {
         if(type == 'cart'){
            this.embryoService.removeLocalCartProduct(value);
         } 
      }
   }

   public selectedCurrency(value) {
      this.embryoService.currency = value;
   }

   public selectedLanguage(value) {
      this.embryoService.language = value;
   }

  

}
